import type { ProviderProfile } from "../../types";

export function isProviderProfile(profile: unknown): profile is ProviderProfile {
  return typeof profile === "object" && profile !== null && "provider_type" in profile;
}
